import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SearchWordService extends ApiService<any> {
  constructor(http: HttpClient) {
    super(http);
    this.url = 'pdf/';
  }

  searchWords(pdfId: number, words: string[], wholeWords: boolean): Observable<any> {
    const params: any = { attachmentId: pdfId };
    const result: { standaloneWords?: string[]; phrases?: string[] } = {};

    if (words && words.length > 0) {
      if (wholeWords) {
        result.standaloneWords = words;
      } else {
        result.phrases = words;
      }
    }

    return this.post({
      url: 'search-words',
      params,
      body: result,
    });
  }
}
